// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__color-text__off {
  from {
    color: var(--av-color-text, var(--color-text));
  }
  to {
    color: var(--color-text);
  }
}
@keyframes avMode__color-text__on {
  from {
    color: var(--color-text);
  }
  to {
    color: var(--av-color-text, var(--color-text));
  }
}
.av-mode.av-mode__color-text {
  color: var(--color-text);
}
.av-mode.av-mode__color-text.av-mode__off {
  animation: 1.2s avMode__color-text__off forwards;
}
.av-mode.av-mode__color-text.av-mode__off .rte h1,
.av-mode.av-mode__color-text.av-mode__off .rte h2,
.av-mode.av-mode__color-text.av-mode__off .rte h3,
.av-mode.av-mode__color-text.av-mode__off .rte h4,
.av-mode.av-mode__color-text.av-mode__off .rte h5,
.av-mode.av-mode__color-text.av-mode__off .rte h6,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h1,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h2,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h3,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h4,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h5,
.av-mode.av-mode__color-text.av-mode__off .shopify-policy__body h6,
.av-mode.av-mode__color-text.av-mode__off .play-button-block__inner > .play-button-block-right {
  animation: 1.2s avMode__color-text__off forwards;
}
.av-mode.av-mode__color-text.av-mode__on {
  animation: 1.2s avMode__color-text__on forwards;
}
.av-mode.av-mode__color-text.av-mode__on .rte h1,
.av-mode.av-mode__color-text.av-mode__on .rte h2,
.av-mode.av-mode__color-text.av-mode__on .rte h3,
.av-mode.av-mode__color-text.av-mode__on .rte h4,
.av-mode.av-mode__color-text.av-mode__on .rte h5,
.av-mode.av-mode__color-text.av-mode__on .rte h6,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h1,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h2,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h3,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h4,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h5,
.av-mode.av-mode__color-text.av-mode__on .shopify-policy__body h6,
.av-mode.av-mode__color-text.av-mode__on .play-button-block__inner > .play-button-block-right {
  animation: 1.2s avMode__color-text__on forwards;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__color-text.scss"],"names":[],"mappings":"AAUA;EACE;IARA,8CAAA;EAAA;EAYA;IARA,wBAAA;EADA;AACF;AAaA;EACE;IAdA,wBAAA;EAIA;EAcA;IAtBA,8CAAA;EAWA;AACF;AAgBE;EAxBA,wBAAA;AAWF;AAgBI;EACE,gDAAA;AAdN;AAgBM;;;;;;;;;;;;;EAaE,gDAAA;AAdR;AAkBI;EACE,+CAAA;AAhBN;AAkBM;;;;;;;;;;;;;EAaE,+CAAA;AAhBR","sourcesContent":["@import './av-mode__vars.scss';\n\n@mixin on() {\n  color: var(--av-color-text, var(--color-text));\n}\n\n@mixin off() {\n  color: var(--color-text);\n}\n\n@keyframes avMode__color-text__off {\n  from {\n    @include on;\n  }\n\n  to {\n    @include off;\n  }\n}\n\n@keyframes avMode__color-text__on {\n  from {\n    @include off;\n  }\n\n  to {\n    @include on;\n  }\n}\n\n.av-mode {\n  &.av-mode__color-text {\n    @include off;\n\n    &.av-mode__off {\n      animation: $animation-duration avMode__color-text__off forwards;\n\n      .rte h1,\n      .rte h2,\n      .rte h3,\n      .rte h4,\n      .rte h5,\n      .rte h6,\n      .shopify-policy__body h1,\n      .shopify-policy__body h2,\n      .shopify-policy__body h3,\n      .shopify-policy__body h4,\n      .shopify-policy__body h5,\n      .shopify-policy__body h6,\n      .play-button-block__inner > .play-button-block-right {\n        animation: $animation-duration avMode__color-text__off forwards;\n      }\n    }\n\n    &.av-mode__on {\n      animation: $animation-duration avMode__color-text__on forwards;\n\n      .rte h1,\n      .rte h2,\n      .rte h3,\n      .rte h4,\n      .rte h5,\n      .rte h6,\n      .shopify-policy__body h1,\n      .shopify-policy__body h2,\n      .shopify-policy__body h3,\n      .shopify-policy__body h4,\n      .shopify-policy__body h5,\n      .shopify-policy__body h6,\n      .play-button-block__inner > .play-button-block-right {\n        animation: $animation-duration avMode__color-text__on forwards;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
